import { PlusIcon } from '@phosphor-icons/react';
import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { Avatar, AvatarFallback, AvatarImage, Icon } from '@sr/ui-library';
import clsx from 'clsx';
import { useEffect } from 'react';
import { Navbar } from 'react-daisyui';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { userService } from '../../reducers/permissions/userSlice';
import { workspaceService } from '../../reducers/workspaces/workspaceSlice';
import { useAppDispatch, useTypedSelector } from '../../stateStore';
import { AuthHelper } from '../../utils/auth/authHelper';
import { isInternalUser, userInitials } from '../../utils/helpers/common';
import IfFeatureEnabled from '../IfFeatureEnabled';
import { PrefetchingNavLink } from '../PrefetchingNavLink';

export const WorkspaceSidebarIcons = () => {
  const dispatch = useAppDispatch();

  const currentUser = useTypedSelector(userService.selectors.userMe);

  const workspaces = useTypedSelector(workspaceService.selectors.workspaces);

  useEffect(() => {
    if (!currentUser) return;

    if (
      AuthHelper.forUser(currentUser).currentUserHasPermission(
        PermissionEnum.ViewWorkspace,
      )
    ) {
      dispatch(workspaceService.findAll());
    }
  }, [currentUser, dispatch]);

  if (isInternalUser(currentUser) || workspaces?.length === 0) {
    return <></>;
  }

  return (
    <>
      <Navbar className="flex-col p-0">
        <Navbar.Start className="modal-avatar block w-full">
          {workspaces
            ?.slice(0, 5)
            .map(({ _id: workspaceId, imageUri, workspaceName }) => {
              return (
                <PrefetchingNavLink
                  key={workspaceId}
                  className={({ isActive }) => {
                    return twMerge(
                      'avatar z-10 w-full justify-center py-4',
                      clsx({ active: isActive }),
                    );
                  }}
                  to={`/workspace/${workspaceId}`}
                >
                  {/* TODO: Review these classes to make it look better */}
                  <Avatar className="h-14 w-14 rounded-2xl border-2 border-sr-black bg-neutral text-neutral-content hover:border-2 hover:border-neutral">
                    <AvatarImage src={imageUri} />
                    <AvatarFallback className="bg-neutral">
                      {userInitials(workspaceName)}
                    </AvatarFallback>
                  </Avatar>
                </PrefetchingNavLink>
              );
            })}
        </Navbar.Start>
        <Navbar.End className="w-full">
          <IfFeatureEnabled name="sidebarAddWorkspaceButton">
            <Link
              className="mb-10 mt-10 border-2 border-sr-black p-2.5 hover:rounded-2xl hover:border-neutral"
              to="/workspace/add"
            >
              <Icon icon={PlusIcon} size="xl" />
            </Link>
          </IfFeatureEnabled>
          <IfFeatureEnabled name="sidebarViewAllWorkspaces">
            {workspaces.length > 4 && (
              <Link
                className="absolute bottom-0 left-0 w-full pb-3.5 text-sm"
                to="/workspace"
              >
                View All
              </Link>
            )}
          </IfFeatureEnabled>
        </Navbar.End>
      </Navbar>
    </>
  );
};
